import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useApp } from "../context/AppContext";
import { useAuth, errCode, startGoogleLogin } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* Exchanges the Emergent Google Auth session_id (URL fragment) for an app session. */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { saveSession } = useAuth();
  const { t } = useApp();
  const processed = useRef(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const portal = sessionStorage.getItem("do_auth_portal") || "farmer";
    sessionStorage.removeItem("do_auth_portal");
    window.history.replaceState(null, "", "/auth/callback");
    if (!sessionId) { navigate(portal === "admin" ? "/admin/login" : "/auth", { replace: true }); return; }
    axios.post(`${API}/auth/google/session`, { session_id: sessionId, portal }, { withCredentials: true, timeout: 30000 })
      .then(({ data }) => {
        saveSession(data);
        toast.success(t("auth.google_ok"));
        navigate(data.user.is_admin ? "/admin" : "/dashboard", { replace: true, state: { user: data.user } });
      })
      .catch((e) => {
        const code = e?.response ? errCode(e) : "GOOGLE_EXCHANGE_FAILED";
        const key = `err.${code === "GENERIC" ? "GOOGLE_EXCHANGE_FAILED" : code}`;
        toast.error(t(key), { duration: 8000 });
        setFailed(portal);
      });
  }, [navigate, saveSession, t]);

  return (
    <main className="auth-page" data-testid="auth-callback">
      <div className="auth-card auth-callback-card">
        <span className="tour-logo">واحة التمور</span>
        <p className="admin-muted" data-testid="auth-callback-status">{failed ? t("auth.google_failed") : t("auth.google_wait")}</p>
        {!failed && <span className="k-shimmer" />}
        {failed && (
          <div className="auth-callback-actions">
            <button type="button" className="btn-lux" onClick={() => startGoogleLogin(failed)} data-testid="auth-callback-retry">{t("auth.google_retry")}</button>
            <button type="button" className="btn-lux-ghost" onClick={() => navigate(failed === "admin" ? "/admin/login" : "/auth", { replace: true })} data-testid="auth-callback-back">{t("auth.google_back")}</button>
          </div>
        )}
      </div>
    </main>
  );
}
